import moment from 'moment-timezone';
import { getRunMode } from '@/utils';

/** NOL 카드 페이로 호텔 결제 이벤트(v31) 종료 시점 (KST) */
const NOL_CARD_PAY_EVENT_END_AT_KST = '2026-08-04T00:00:00+09:00';

/**
 * 2026년 8월 4일 자정(KST) 이후 여부 - NOL 카드 페이 이벤트 종료 여부 판단에 사용
 * dev/qa 환경에서는 테스트를 위해 날짜와 무관하게 항상 false(진행중)를 반환한다.
 */
export const isNolCardPayEventEnded = (): boolean => {
  if (['local', 'development', 'qa'].includes(getRunMode())) {
    return true;
  }

  return moment().isSameOrAfter(moment(NOL_CARD_PAY_EVENT_END_AT_KST));
};
